import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Router,
  RouterLink,
  NavigationEnd,
  NavigationSkipped,
} from '@angular/router';
import { BASE_LINKS } from '@features/header/constants/navigation';
import { SessionService } from '@core/services/session.service';
import { UIService } from '@core/services/ui.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { filter, Subscription } from 'rxjs';
import { HeaderNavigation } from '../interfaces/header-navigation.interface';
import { ModalService } from '@features/modals/services/modal.service';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';

@Component({
  selector: 'app-header-navigation',
  imports: [RouterLink, SvgIconComponent, BalanceIconComponent],
  standalone: true,
  templateUrl: './header-navigation.component.html',
  styleUrl: './header-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex items-center justify-center',
  },
})
export class HeaderNavigationComponent {
  readonly routes = BASE_LINKS;
  featureRoutes = computed<HeaderNavigation[]>(() => {
    return [
      {
        icon: 'assets/icons/ui/output.svg',
        title: 'Withdraw',
        color: 'yellow',
        link: 'withdraw',
        hide: !this.uiService.breakpoints().max_lg,
      },
      {
        icon: 'assets/icons/features/rewards.svg',
        title: 'Rewards',
        color: 'green',
        link: 'rewards',
      },
      {
        icon: 'assets/icons/features/affiliates.svg',
        title: 'Affiliates',
        color: 'yellow',
        link: 'affiliates',
      },
      {
        icon: 'assets/icons/shared/admin.svg',
        title: 'Admin Panel',
        color: 'green',
        link: 'admin',
        hide: !this.sessionService.is_admin(),
      },
    ];
  });

  private destroyRef = inject(DestroyRef);
  public sessionService = inject(SessionService);
  private uiService = inject(UIService);
  private router = inject(Router);
  private modalService = inject(ModalService);

  private routerEventsSubscription: Subscription | null = null;

  constructor() {
    afterNextRender(() => {
      this.routerEventsSubscription?.unsubscribe();
      this.routerEventsSubscription = null;

      if (this.uiService.breakpoints().max_lg) {
        let isFirstRender = true;
        const events = this.router.events.pipe(
          filter(
            (event) =>
              event instanceof NavigationEnd ||
              event instanceof NavigationSkipped
          )
        );

        this.routerEventsSubscription = events
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => {
            if (isFirstRender) {
              isFirstRender = false;
              return;
            }
            this.uiService.isShowChat.set(false);
          });
      }
    });
  }

  public handleOpenAffiliatesRewardModal() {
    this.modalService.openModal('AffiliatesClaimModalComponent');
  }
}
